
// slide toggle class feature
$(document).ready(function(){
    // open child menu when parent-menu clicked
    $('.sidebar-menu-parent-items li').on('click', function(e){
        $('.sidebar-menu-child-wrap').toggleClass('items-hidden');
        $('.sidebar-menu-grandchild-wrap').addClass('items-hidden');
    })
    // open grand-child menu when child-menu clicked
    $('.sidebar-menu-child-items li').on('click', function(e){
        $('.sidebar-menu-grandchild-wrap').toggleClass('items-hidden');
    })

    // close child menu when top-back button clicked
    $('.sidebar-child-menu-title').on('click', function(e){
        $('.sidebar-menu-child-wrap').toggleClass('items-hidden');
        $('.sidebar-menu-grandchild-wrap').addClass('items-hidden');
    })
    // close grandchild menu when top-back button clicked
    $('.sidebar-grandchild-menu-title').on('click', function(e){
        $('.sidebar-menu-grandchild-wrap').addClass('items-hidden');
    })


    // close grandchild menu when top-back button clicked
    $('.child-sidebar-open-btn').on('click', function(e){
        $('.sidebar-mega-menu-items').addClass('active');
        $(this).next().addClass('active');
        $(this).parent().siblings().find('.sidebar-menu-child-wrap').removeClass('active');
    })

    $('.sidebar-menu-title1').on('click', function(e){
        $('.sidebar-mega-menu-items').removeClass('active');
        $('.sidebar-mega-menu-items').removeClass('active2');
        $('.sidebar-menu-child-wrap').removeClass('active');
    })


    $('.sidebar-menu-title2').on('click', function(e){
        $('.sidebar-menu-child-wrap').removeClass('active');
        $('.sidebar-mega-menu-items').removeClass('active2');
        $('.sidebar-mega-menu-items').removeClass('active');
    })

    $('.sidebar-menu-item2').on('click', function(e){
        $('.sidebar-mega-menu-items').addClass('active2');
    })

    $('.sidebar-menu-title3').on('click', function(e){
        $(this).parent().removeClass('active');
        $('.sidebar-mega-menu-items').removeClass('active2');
    })

    $('#hamburger_icon').on('click', function(e){
        $('.sidebar-menu').addClass('active');
    })

    $('.sidebar-close-btn, .sidebar-menu-overlay').on('click', function(e){
        $('.sidebar-menu').removeClass('active');
    })
    // end of script 

    $('#language').on('change', function(){
        var lang = $(this).find(':selected').val();
        $('#language_iso_code').val(lang);
        $('#language_form').submit();
    })
      
})